module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit_wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tip_word"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_vm._v("友情提示：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', {
    staticClass: "grid-content f12 f666 lh20"
  }, [_vm._v("1.请按照大V服务平台信息要求填写正确的供应商信息。")])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 2
    }
  }, [_c('div', {
    staticClass: "grid-content f12 f666 lh20"
  }, [_vm._v("2.所有资质信息格式要求：复印件加盖公司红章之后，再扫描上传到大V服务平台。请确保证件内容清晰可见，扫描件大小不得超过1M。")])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 2
    }
  }, [_c('div', {
    staticClass: "grid-content f12 f666 lh20"
  }, [_vm._v("3.提交审核之后，大V店工作人员会在3个工作日内进行审核。")])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 2
    }
  }, [_c('div', {
    staticClass: "grid-content f12 f666 lh20"
  }, [_vm._v("4.入驻过程有任何疑问，请按照如下方式解决："), _c('br'), _vm._v("（1）如果有对接的采销，请直接联系采销处理解决；"), _c('br'), _vm._v("（2）如果还未对接采销，直接发送问题至邮箱：bd@davdian.com 。")])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 2
    }
  }, [_c('div', {
    staticClass: "grid-content f12 f666 lh20"
  }, [_vm._v("5."), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/suppliers/index2/#/intro"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#58b7ff"
    }
  }, [_vm._v("点击此处")])]), _vm._v("查看供应商入驻介绍。")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt20 ovh min_height"
  }, [(_vm.showButton == 1) ? _c('router-link', {
    attrs: {
      "to": _vm.categoryIsBook == 1 ? '/add_brand?supplierApplyId=' + _vm.supplierApplyId + '&id=0&registeredCountry=' + _vm.registeredCountry : '/notbook_addbrand?supplierApplyId=' + _vm.supplierApplyId + '&id=0&registeredCountry=' + _vm.registeredCountry
    }
  }, [_c('el-button', {
    staticClass: "r mr20 mb20",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("申请品牌")])], 1) : _vm._e(), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.brandList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "brandName",
      "label": "品牌中文名称",
      "min-width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "brandEnname",
      "label": "品牌英文名称",
      "min-width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "categoryName",
      "label": "经营品类",
      "align": "center",
      "min-width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.supplierApplyBrandCategories), function(category) {
          return _c('p', [_vm._v(_vm._s(category.category.grandName) + "-" + _vm._s(category.category.parentName) + "-" + _vm._s(category.category.childrenName))])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "statusDesc",
      "label": "审核状态",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.showButton == 1 || _vm.showEditButton == 1) ? _c('router-link', {
          attrs: {
            "to": _vm.categoryIsBook == 1 ? '/add_brand?id=' + scope.row.brandApplyId + '&supplierApplyId=' + _vm.supplierApplyId + '&registeredCountry=' + _vm.registeredCountry : '/notbook_addbrand?id=' + scope.row.brandApplyId + '&supplierApplyId=' + _vm.supplierApplyId + '&registeredCountry=' + _vm.registeredCountry
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          }
        }, [_vm._v("编辑")])], 1) : _vm._e(), _vm._v(" "), (_vm.showButton == 1) ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.deleBrand(scope.row.brandApplyId)
            }
          }
        }, [_vm._v("删除")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tc mt50 mb50"
  }, [_c('el-button', {
    staticClass: "mr50",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goBasic
    }
  }, [_vm._v("上一步")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.isNoNext,
      "type": "primary"
    },
    on: {
      "click": _vm.goFinan
    }
  }, [_vm._v("下一步")])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit_top"
  }, [_c('div', {
    staticClass: "edit_tab"
  }, [_vm._v("供应商信息")]), _c('div', {
    staticClass: "edit_tab active_tab"
  }, [_vm._v("品牌信息")]), _c('div', {
    staticClass: "edit_tab"
  }, [_vm._v("财务信息")]), _c('div', {
    staticClass: "edit_tab"
  }, [_vm._v("合同协议")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07266cdc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/edit/brandInfo.vue
// module id = 483
// module chunks = 0